import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import IconButton from "material-ui/IconButton";
import Button from "material-ui/Button";
import Hidden from "material-ui/Hidden";
import Typography from "material-ui/Typography";

// material-ui icons
import Menu from "@material-ui/icons/Menu";
import MoreVert from "@material-ui/icons/MoreVert";
import ViewList from "@material-ui/icons/ViewList";

// core components
import HeaderLinks from "./HeaderLinks";
import CustomIconButton from "../../components/CustomButtons/IconButton.jsx";

import headerStyle from "../../assets/jss/material-dashboard-pro-react/components/headerStyle.jsx";
import {toJS} from "mobx";


// function Header({ ...props }) {
//   function makeBrand() {
//     let name;
//     props.routes.map((prop, key) => {
//       if (prop.path === props.location.pathname) {
//         name = prop.navbarName;
//       }
//       return null;
//     });
//     return name;
//   }
//   const { classes, color } = props;
//   const appBarClasses = cx({
//     [" " + classes[color]]: color
//   });
//
//
//   function logout() {
//       props.store.appState.logout();
//   }
//
//   return (
//     <AppBar className={classes.appBar + appBarClasses}>
//       <Toolbar className={classes.container}>
//         <div className={classes.flex}>
//             <a href={"/dashboard"}>
//                 <img src={require("../../assets/img/akindalogo.png")} width={100}/>
//             </a>
//         </div>
//         <Hidden smDown implementation="css">
//             <Button href="#" className={classes.title} onClick={function(){logout()}}>
//                 {'Log out'}
//             </Button>
//         </Hidden>
//       </Toolbar>
//     </AppBar>
//   );
// }




function Header({ ...props }) {

  function makeBrand() {

    let name;
    props.routes.map((prop, key) => {
      if (prop.collapse) {
        prop.views.map((prop, key) => {
          if (prop.path === props.location.pathname) {
            name = prop.name;
          }
          return null;
        });
      }
      if (prop.path === props.location.pathname) {
        name = prop.name;
      }
      return null;
    });

    return name;
  }

  function logout() {
    props.store.appState.logout();
  }

  const DEFAULT_TEXT = toJS(props.store.appState.DEFAULT_TEXT);

  const { classes, color, rtlActive } = props;

  // const classH2 = classes.title+ " MuiButton-root-124";

  const appBarClasses = cx({
    [" " + classes[color]]: color
  });

  const sidebarMinimize =
    classes.sidebarMinimize +
    " " +
    cx({
      [classes.sidebarMinimizeRTL]: rtlActive
    });


  return (
   
    <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        
        <Hidden smDown>
          <div className={sidebarMinimize}>
            {props.miniActive ? (
              <CustomIconButton color="white" onClick={props.sidebarMinimize}>
                <ViewList className={classes.sidebarMiniIcon} />
              </CustomIconButton>
            ) : (
              <CustomIconButton color="white" onClick={props.sidebarMinimize}>
                <MoreVert className={classes.sidebarMiniIcon} />
              </CustomIconButton>
            )}
          </div>
        </Hidden>

        <div className={classes.flex}>
          <Typography variant="h1" component="h2" gutterBottom className={classes.title} style={{padding: '8px 16px', minWidth: '88px', minHeight: '36px' }} >
            {makeBrand()}
          </Typography>
        </div>
        
        <Hidden smDown implementation="css">
           <Button href="#" className={classes.title} onClick={function(){logout()}} >
               {DEFAULT_TEXT.logout}
           </Button>
        </Hidden>

        <Hidden smDown implementation="css">
          <HeaderLinks rtlActive={rtlActive} />
        </Hidden>
        <Hidden mdUp>
          <IconButton
            className={classes.appResponsive}
            color="inherit"
            aria-label="open drawer"
            onClick={props.handleDrawerToggle}
          >
            <Menu />
          </IconButton>
        </Hidden>

      </Toolbar>
    </AppBar>

  );
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool
};

export default withStyles(headerStyle)(Header);


// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx